<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script setup lang="ts"></script>
<style scoped>
#app {
  overscroll-behavior-y: none;
  width: 100vw;
  height: 100%;
}
</style>
